import useSWR from "swr"
import { simpleGet } from "@/lib/apiUtils"
import type { ReportNotificationSummary } from "@/types/reports"

interface UnreadNotesData {
	unreadCount: number
	summaries: ReportNotificationSummary[]
}

interface UseUnreadNotesProps {
	userId?: string
	userRole?: string
	userOrganizationId?: string
	realTime?: boolean // kept for API compat, ignored (SWR polling replaces onSnapshot)
}

const fetcher = (url: string) => simpleGet<UnreadNotesData>(url)

export const useUnreadNotes = ({ userId }: UseUnreadNotesProps) => {
	const { data, error, isLoading, mutate } = useSWR(
		userId ? "/api/reports/notes/unread" : null,
		fetcher,
		{
			refreshInterval: 60000, // Poll every 60 seconds
			revalidateOnFocus: false, // Prevent rapid revalidation on tab focus
			dedupingInterval: 10000, // Deduplicate requests within 10 seconds
		}
	)

	return {
		unreadCount: data?.unreadCount ?? 0,
		summaries: data?.summaries ?? [],
		loading: isLoading,
		error: error ? (error instanceof Error ? error.message : "Failed to load unread notes") : null,
		refreshUnreadCount: () => mutate(),
	}
}
